import React from 'react';
import './index.scss';
import brandLogo from '../../../images/brandLogo.gif';
var Spinner = function () {
    // return <div className="spinner site-color"></div>  
    return React.createElement("div", { id: 'brand-loader' },
        React.createElement("img", { src: brandLogo }));
};
export default Spinner;
